import type { Evidence } from '@areapif/areapif-shared'
import { InspectionEvidenceType } from '@areapif/areapif-shared'

// Local evidence format for gallery display
export interface GalleryEvidence {
  id: string
  type: 'photo' | 'seal'
  category?: string
  serialId?: string
  url?: string
}

/**
 * Convert shared library Evidence to gallery evidence format
 */
export const convertToGalleryEvidence = (evidence: Evidence[]): GalleryEvidence[] => {
  return evidence.map(item => ({
    id: item.path,
    type: item.type === InspectionEvidenceType.SEAL ? 'seal' : 'photo',
    category: item.type === InspectionEvidenceType.SEAL ? item.category : undefined,
    serialId: item.type === InspectionEvidenceType.SEAL ? item.serialId : undefined,
    url: item.path,
  }))
}
